export default __webpack_public_path__ + "tmp_src/components/Collection/CollectionMobileActions.css.liquid";